import beef_burger from '../assets/foods/Sandwitches/beef_burger.jpg'
import beef_shawarma_wrap from '../assets/foods/Sandwitches/beef_shwarma_wrap.jpg'
import chicken_shawarma_wrap from '../assets/foods/Sandwitches/chicken_shawarma_wrap.jpg'
import crispy_wrap from '../assets/foods/Sandwitches/crispy.jpg'
import tawook_wrap from '../assets/foods/Sandwitches/tawook.jpg'
import fajita_wrap from '../assets/foods/Sandwitches/Fajita.jpg'
import fries_wrap from '../assets/foods/Sandwitches/fries.jpg'

import full_chicken_rice from '../assets/foods/dishes/chicken_rice.jpg'
import half_chicken_rice from '../assets/foods/dishes/half_chicken_rice.jpg'
import chicken_shawarma_rice from '../assets/foods/dishes/chicken_shawarma_rice.jpg'
import beef_shawarma_rice from '../assets/foods/dishes/beef_shawarma_rice.jpg'
import crispy_chicken_rice from '../assets/foods/dishes/crispy_chicken_rice.jpg'
import tawook_rice from '../assets/foods/dishes/tawouk_rice.jpg'
import sawa_chicken_rice from '../assets/foods/dishes/sawa_rice.jpg'

import chicken_meal from '../assets/foods/meals/chicken_meal.jpg'
import half_chicken_meal from '../assets/foods/meals/half_chicken_meal.jpg'
import chicken_shawarma_meal from '../assets/foods/meals/chicken_shawarma_meal.jpg'
import beef_shawarma_meal from '../assets/foods/meals/beef_shawarma_meal.jpg'
import tawook_meal from '../assets/foods/meals/tawook_meal.jpg'
import crispy_meal from '../assets/foods/meals/crispy_meal.jpg'
import burger_meal from '../assets/foods/meals/burger_meal.jpg'

import soft_drinks from '../assets/foods/drinks/soft_drink.jpg'
import yogurt from '../assets/foods/drinks/yogurt.jpg'
import water from '../assets/foods/drinks/water.jpg'

export const translations = {
	en: {
		menu: {
			SandwichSection: {
				title: "Sandwiches",
				items: {
					item1: { image: chicken_shawarma_wrap, name: "Chicken Shawarma", description: "Grilled chicken wrap", price: "$4.5" },
					item2: { image: beef_shawarma_wrap, name: "Beef Shawarma", description: "Juicy beef wrap", price: "$6" },
					item3: { image: beef_burger, name: "Burger", description: "Classic beef burger", price: "$4" },
					item4: { image: crispy_wrap, name: "Crispy", description: "Crispy chicken wrap", price: "$4" },
					item5: { image: tawook_wrap, name: "Tawouk", description: "Grilled chicken skewer", price: "$4" },
					item6: { image: fajita_wrap, name: "Fajita", description: "Spicy chicken wrap", price: "$6" },
					item7: { image: fries_wrap, name: "Fries", description: "Golden crispy fries", price: "$1.7" },
				}
			},
			RiceSection: {
				title: "Rice Dishes",
				items: {
					item1: { image: full_chicken_rice, name: "Chicken Rice", description: "Rice with grilled chicken", price: "$11.5" },
					item2: { image: half_chicken_rice, name: "Half Chicken Rice", description: "Half chicken with rice", price: "$6" },
					item3: { image: chicken_shawarma_rice, name: "Chicken Shawarma Rice", description: "Rice with chicken shawarma", price: "$7" },
					item4: { image: beef_shawarma_rice, name: "Beef Shawarma Rice", description: "Rice with beef shawarma", price: "$8.5" },
					item5: { image: crispy_chicken_rice, name: "Crispy with Rice", description: "Crispy chicken with rice", price: "$7" },
					item6: { image: tawook_rice, name: "Tawouk with Rice", description: "Tawouk with rice", price: "$7" },
					item7: { image: sawa_chicken_rice, name: "Sawa Rice", description: "Traditional seasoned rice", price: "$3.5" },
				}
			},
			MealsSection: {
				title: "Meals",
				items: {
					item1: { image: chicken_meal, name: "Chicken", description: "Grilled chicken meal", price: "$8.5" },
					item2: { image: half_chicken_meal, name: "Half Chicken", description: "Half grilled chicken", price: "$5" },
					item3: { image: chicken_shawarma_meal, name: "Chicken Shawarma", description: "Chicken shawarma plate", price: "$8" },
					item4: { image: beef_shawarma_meal, name: "Beef Shawarma", description: "Beef shawarma plate", price: "$10" },
					item5: { image: tawook_meal, name: "Tawouk", description: "Grilled tawouk meal", price: "$7" },
					item6: { image: crispy_meal, name: "Crispy", description: "Crispy chicken meal", price: "$7" },
					item7: { image: burger_meal, name: "Burger", description: "Beef burger meal", price: "$7" },
					item8: { image: burger_meal, name: "Fries", description: "[very short descreption]", price: "$7" },
				}
			},
			DrinksSection: {
				title: "Drinks",
				items: {
					item1: {image: soft_drinks, name: "Soft drink", description:"", price: "$0.80"},
					item2: {image: yogurt, name: "yogurt drink", description:"", price: "$0.80"},
					item3: {image: water, name: "water", description:"", price: "$0.30"},
				}
			}
		},
		openingTimes: {
			title: "Opening Times",
			baseDays: "11AM - 12PM",
		},
		copied: "Copied to clipboard!",
		unit: "LBP"
	},
	ar: {
		menu: {
			SandwichSection: {
				title: "السندويشات",
				items: {
					item1: { image: chicken_shawarma_wrap, name: "شاورما دجاج", description: "لفة دجاج مشوي", price: "$4.5" },
					item2: { image: beef_shawarma_wrap, name: "شاورما لحم", description: "لفة لحم شهية", price: "$6" },
					item3: { image: beef_burger, name: "برجر", description: "برجر لحم كلاسيكي", price: "$4" },
					item4: { image: crispy_wrap, name: "كريسبي", description: "لفة دجاج مقرمش", price: "$4" },
					item5: { image: tawook_wrap, name: "طاووق", description: "شيش طاووق مشوي", price: "$4" },
					item6: { image: fajita_wrap, name: "فاهيتا", description: "لفة دجاج حارة", price: "$6" },
					item7: { image: fries_wrap, name: "بطاطا مقلية", description: "بطاطا ذهبية مقرمشة", price: "$1.7" },
				}
			},
			RiceSection: {
				title: "أطباق الأرز",
				items: {
					item1: { image: full_chicken_rice, name: "أرز مع دجاج", description: "طبق أرز مع فروج مشوي", price: "$11.5" },
					item2: { image: half_chicken_rice, name: "أرز مع نصف دجاجة", description: "طبق نصف فروج مع أرز", price: "$6" },
					item3: { image: chicken_shawarma_rice, name: "أرز مع شاورما دجاج", description: "طبق أرز مع شاورما الدجاج", price: "$7" },
					item4: { image: beef_shawarma_rice, name: "أرز مع شاورما لحم", description: "طبق أرز مع شاورما اللحم", price: "$8.5" },
					item5: { image: crispy_chicken_rice, name: "أرز مع كريسبي", description: "طبق أرز مع كرسبي", price: "$7" },
					item6: { image: tawook_rice, name: "أرز مع طاووق", description: "طبق أرز مع شيش طاووق", price: "$7" },
					item7: { image: sawa_chicken_rice, name: "أرز ساوة", description: "طبق أرز متبل تقليدي", price: "$3.5" },
				}
			},
			MealsSection: {
				title: "الوجبات",
				items: {
					item1: { image: chicken_meal, name: "فروج", description: "وجبة دجاج مشوي", price: "$8.5" },
					item2: { image: half_chicken_meal, name: "نصف فروج", description: "نصف دجاجة مشوية", price: "$5" },
					item3: { image: chicken_shawarma_meal, name: "شاورما دجاج", description: "طبق شاورما دجاج", price: "$8" },
					item4: { image: beef_shawarma_meal, name: "شاورما لحم", description: "طبق شاورما لحم", price: "$10" },
					item5: { image: tawook_meal, name: "طاووق", description: "وجبة شيش طاووق", price: "$7" },
					item6: { image: crispy_meal, name: "كريسبي", description: "وجبة دجاج مقرمش", price: "$7" },
					item7: { image: burger_meal, name: "برجر", description: "وجبة برجر لحم", price: "$7" },
				},			
			},
			DrinksSection: {
				title: "المرطبات",
				items: {
					item1: { image: soft_drinks, name: "مشروب غازي", price: "$0.80" },
					item2: { image: yogurt, name: "عيران", price: "$0.80" },
					item3: { image: water, name: "ماء", price: "$0.30" },
				}
			}
		},
		openingTimes: {
			title: "أوقات العمل",
			baseDays: "11 صباحًا - 12 مساءً",
		},
		copied: " تم النسخ إلى الحافظة !",
		unit: "ل.ل."
	}
};
